import type { IconData } from '@stacksjs/iconify-core'

export const loadingHorizontal2Flat: IconData = {
  "body": "<path fill=\"#8fbffa\" fill-rule=\"evenodd\" d=\"M33.5 24a9.5 9.5 0 1 0-19 0a9.5 9.5 0 0 0 19 0m-21 0a5.5 5.5 0 1 0-11 0a5.5 5.5 0 0 0 11 0M41 18.5a5.5 5.5 0 1 1 0 11a5.5 5.5 0 0 1 0-11\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default loadingHorizontal2Flat
